<template>


    <div class="app-layer admin" @click="layerClick($event)">

      <transition name="right-modal" v-show="show">

        <div class="modal-custom right" name="sync-info-admin" v-if="show" :class="{loading: loading}">

          <span class="close" @click="closeModal()">chiudi</span>

          <div class="content">

            <h2 class="m-0">Preferenze aggiornamenti</h2>

            <p>Imposta le tue preferenze di comunicazione sugli aggiornamenti</p>

            <div v-if="$parent.sync_info_admin && $parent.sync_info_admin.active !== null">

              <v-switch2 :label="'Attivare il servizio mail'" v-model="$parent.sync_info_admin.active"/>
              <p class="subdesc">{{trans.get('sync.info_admin.active')}}</p>

              <div class="values-sync-info" :class="{'disabled-form': !$parent.sync_info_admin.active}">

                <div class="field">

                  <span>{{trans.get('sync.info_admin.email')}}</span><br>
                  <input type="text" placeholder=" * email" name="email_admin_sync" v-model="$parent.sync_info_admin.email">
                  <div class="field-error" v-if="!isFirstSubmit && sync_info_admin.active && !is_email($parent.sync_info_admin.email)">
                    <span>Email obbigatoria: inserire un formato valido</span>
                  </div>
                </div>

                <h3 class="">Avanzate</h3>

                <div class="field mt-1">
                  <span>INIZIO</span>
                  <v-checkbox2 :label="trans.get('sync.info_admin.start')" v-model="$parent.sync_info_admin.start"/>
                </div>

                <div class="field mt-1">
                  <span>FINE</span>
                  <v-checkbox2 :label="trans.get('sync.info_admin.end')" v-model="$parent.sync_info_admin.end"/>
                  <span>- Quando?</span>
                  <v-select :options="getEndOptions"
                            v-model="$parent.sync_info_admin.end_val"
                            :reduce="option => option.value">
                  </v-select>
                </div>

                <div class="field mt-1">
                  <span>- {{trans.get('sync.info_admin.seconds')}}</span><br>
                  <input type="number" name="seconds" min="0" step="1" v-model.number="$parent.sync_info_admin.seconds">
                  <span class="subdesc size-09">({{getSeconds}})</span>
                </div>

                <div class="field mt-1">
                  <span>- {{trans.get('sync.info_admin.models')}}</span>


                  <v-select class="vs--multiple" placeholder=" Default tutte le entità"
                            multiple :options="getModelsSync" :closeOnSelect="false"
                            v-model="$parent.sync_info_admin.models"
                            :reduce="option => option.value"
                            :selectable="option => $parent.sync_info_admin.models.indexOf(option.value) < 0">

                  </v-select>
                </div>

                <div class="field mt-1">
                  <span>TIPO AGGIORNAMENTO</span><br>
                  <span class="subdesc">{{trans.get('sync.info_admin.type_sync')}}</span>
                  <v-select class="vs--multiple" placeholder=" Default tutti i tipi"
                            multiple :options="getTypeSync" :closeOnSelect="false"
                            v-model="$parent.sync_info_admin.type_sync"
                            :reduce="option => option.value"
                            :selectable="option => $parent.sync_info_admin.type_sync.indexOf(option.value) < 0">

                  </v-select>
                </div>

                <div class="field mt-1">
                  <span>ORARIO AGGIORNAMENTO</span><br>
                  <span class="subdesc">{{trans.get('sync.info_admin.clock_sync')}}</span>
                  <v-select class="vs--multiple" placeholder=" Default tutti gli intervalli orari"
                            multiple :options="getClockSync" :closeOnSelect="false"
                            v-model="$parent.sync_info_admin.clock_sync"
                            :reduce="option => option.value"
                            :selectable="option => $parent.sync_info_admin.clock_sync.indexOf(option.value) < 0">
                  </v-select>
                </div>

                <div class="field mt-1">
                  <span>NOTIFICA GLI ALTRI AMMINISTRATORI</span><br>
                  <v-checkbox2 :label="trans.get('sync.info_admin.notify_admin')" v-model="$parent.sync_info_admin.notify_admin"/>
                  <v-select class="vs--multiple" placeholder=" Default tutti gli amministratori con attivo il servizio"
                            multiple :options="$parent.sync_admins" :closeOnSelect="true"
                            v-model="$parent.sync_info_admin.notify_admin_val"
                            :reduce="option => option.id_utente"
                            label="username"
                            :selectable="option => $parent.sync_info_admin.notify_admin_val.indexOf(option.id_utente) < 0">
                            <template #option="option">
                              {{ option.username }} <cite>{{ option.email_sync }}</cite>
                            </template>
                  </v-select>
                </div>

              </div>

              <button class="belt-btn animated mb-1" :class="{loading: loading}" @click="toUpdateInfo()">AGGIORNA PREFERENZE</button>

            </div>
            <div v-else>
              Imposta le tue preferenze sugli aggiornamneti
            </div>

          </div>

        </div>

      </transition>

    </div>

</template>

<script>
export default{

  props: {
    sync_info_admin: {type: Object},
    sync_admins: {type: Array}
  },

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data

      isFirstSubmit: true,

    }

  },

  mounted: function(){

    // show component
    this.show = true;
    // this.loadSyncInfoAdmin();

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.manage_sync_info_admin = false;

  },

  computed: {
    getTransSync: function() {
      return this.trans.messages[this.trans.fallback+'.sync'];
    },

    getModelsSync: function(){
      let models = this.getTransSync.models_sync;
      let modelsArray = [];
      for (let key in models) {
        modelsArray.push({label: models[key], value: key});
      }
      return modelsArray;
    },
    getClockSync: function() {
      let intervals = this.getTransSync.clock_sync;
      let intervalsArray = [];
      for (let key in intervals) {
        intervalsArray.push({label: intervals[key], value: parseInt(key)});
      }
      return intervalsArray;
    },

    getTypeSync: function(){
      let types = this.getTransSync.type_sync;
      let typesArray = [];
      for (let key in types) {
        typesArray.push({label: types[key], value: parseInt(key)});
      }
      return typesArray;
    },

    getEndOptions: function(){
      let options = this.getTransSync.info_admin.end_options;
      let optionsArray = [];
      for (let key in options) {
        optionsArray.push({label: options[key], value: parseInt(key)});
      }
      return optionsArray;
    },

  /** Formato stringa dei secondi espresso in ore min e secondi
    *  Number of days = ⌊ n / (24 * 3600) ⌋
    *  Number of Hours = ⌊ (n % (24 * 3600)) / 3600 ⌋
    *  Number of Minutes = ⌊ (n % (24 * 3600 * 3600)) / 60 ⌋
    *  Number of Seconds = ⌊ (n % (24 * 3600 * 3600 * 60)) / 60 ⌋
    */
    getSeconds: function() {
      var n = this.$parent.sync_info_admin.seconds;
      var _n = n;
      // 24 * 3600 = 86400
      var day = parseInt( n / (86400));

      n = n % (86400);
      var hour = parseInt(n / 3600);

      n %= 3600;
      var minutes = parseInt(n / 60);

      n %= 60;
      var seconds = n;

      var format = [];
      if(day>0)
        format.push(day + ' g');
      if(hour>0)
        format.push(hour + ' h');
      if(minutes>0)
        format.push(minutes.toFixed() + ' m');
      if(seconds>0 || _n == 0)
        format.push(seconds.toFixed() + ' s');

      return format.join(' ');
    }
  },

  methods: {

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 200, this);

    },

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) {
        this.loadSyncInfoAdmin();
        this.closeModal();
      }

    },

    loadSyncInfoAdmin: function() {
      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin + '/data/updating-sync/info-admin'
      })
      .then(res => {
        if( res.data.sync_info_admin ) vue.$parent.sync_info_admin = res.data.sync_info_admin;
        if( res.data.sync_admins ) vue.$parent.sync_admins = res.data.sync_admins;
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile caricare le preferenze sugli aggiornamenti'
        });

      })
      .then(() =>{
        vue.loading = false;
      })
    },

    toUpdateInfo: function(){

      var vue = this;
      vue.isFirstSubmit = false;

      if (!vue.isFirstSubmit && vue.sync_info_admin.active && !this.is_email(vue.sync_info_admin.email)) {
        vue.$store.commit('add_message', {
          type: 'info',
          message: 'Controlla i dati inseriti, c\'è qualche errore'
        });
        return;
      }

      vue.loading = true;
      var settingsInfoAdmin = vue.sync_info_admin;

      axios({
        method: "post",
        url: window.location.origin + '/data/updating-sync/set-info-admin',
        params: {
          json: JSON.stringify(settingsInfoAdmin),
        }
      })
      .then(res => {
        if( res.data.sync_info_admin ) vue.$parent.sync_info_admin = res.data.sync_info_admin;
        if( res.data.sync_admins ) vue.$parent.sync_admins = res.data.sync_admins;
        vue.$store.commit('add_message', {
          type: 'success',
          message: 'Informazioni aggiornate'
        });
      })
      .catch(err => {

        console.log( err.response );

        vue.$store.commit('add_message', {
          type: 'error',
          message: 'Si è verificato un errore, impossibile caricare la lista degli aggiornamenti'
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    is_email: function (pattern) {
      var regex = /^[a-z0-9._-]{3,}@[a-z0-9-]{1,}\.[a-z]{2,10}$/i;
      return regex.test(pattern.trim());
    },


  },


}
</script>

<style scoped>

.modal-custom{
  background-color: white;
  max-width: 800px;
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
}
.values-sync-info {
  position: relative;
}
.values-sync-info.disabled-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  transition: background-color 0.2s ease;
  cursor: no-drop;
}
.values-sync-info:not(.disabled-form)::before {
  width: 0;
  height: 0;
  z-index: -1;
  transition: background-color 0.2s ease;
}
.values-sync-info.disabled-form::before {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 2;
}
p.subdesc,
span.subdesc {
  margin-top: 0;
  color: var(--checkbox-gray);
}
input[name="email_admin_sync"] {
  padding: 2px 4px;
  width: 100%;
  max-width: 300px;
}
input[name="seconds"] {
  padding-left: 2px;
  width: auto;
}

/* ------ Info Error ------ */
.field-error {
    color: var(--red);
    display: flex;
    font-size: 14px;
    line-height: normal;
    margin-top: 2px;
    position: relative;
    padding-left:  0px;
    opacity: 0;
    padding-top: 5px;
    overflow-y: visible;
    height: 0px;
    margin-bottom: 2em;
    animation: moveError 0.2s ease-in forwards;
}
@keyframes moveError {
  100% {
    padding-left:  25px;
    opacity: 1;
  }
}
.field-error::before {
  display: flex;
  align-items: center;
  justify-content: center;
  content: "\0021"; /* ! */
  color: white;
  width: 18px;
  height: 18px;
  top: 5px;
  left: 0;
  position: absolute;
  border-radius: 100%;
  background-color: var(--red) ;
}
</style>
